<div class="tabela-redesign">
  <div class="tabela-redesign-scroll" [style.maxHeight]="maxHeight">
    @if (carregando) {
      <div class="tabela-redesign-skeleton">
        <div class="tabela-skeleton-linha tabela-skeleton-cabecalho">
          @for (coluna of colunasSkeletonArray; track $index) {
            <div class="skeleton tabela-skeleton-bloco"></div>
          }
        </div>
        @for (linha of linhasSkeletonArray; track $index) {
          <div class="tabela-skeleton-linha">
            @for (coluna of colunasSkeletonArray; track $index) {
              <div class="skeleton tabela-skeleton-bloco"></div>
            }
          </div>
        }
      </div>
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>
